import React from 'react';
import './locationcard.css';

interface LocationCardProps {
  homeAddress?: string | null;
  dropoffAddress?: string | null;
  campusName?: string | null;
  onEdit: () => void;
  isEdit?: boolean;
}

export const LocationCard: React.FC<LocationCardProps> = ({ 
  homeAddress,
  dropoffAddress,
  campusName,
  onEdit,
  isEdit = false
}) => {
  // Don't render if neither address is available
  if (!homeAddress && !dropoffAddress) {
    return null;
  }

  return (
    <div className="location-card">
      {isEdit && <div className="location-card__header">
        <button
          className="location-card__edit-btn"
          onClick={onEdit}
        >
          ✏️ Edit
        </button>
      </div>}
      
      <div className="location-card__content">
        {homeAddress && (
          <div className="location-card__item">
            <div className="location-card__item-icon">🏠</div>
            <div>
              <p className="location-card__item-label">Pickup Address</p>
              <p className="location-card__item-address">
                {homeAddress}
              </p>
            </div>
          </div>
        )}

        {dropoffAddress && (
          <div className="location-card__item">
            <div className="location-card__item-icon">🏫</div>
            <div>
              <p className="location-card__item-label">Drop off Address</p>
              {campusName && (
                <p className="location-card__item-campus-name">
                  {campusName}
                </p>
              )}
              <p className="location-card__item-address">
                {dropoffAddress}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationCard;

